
<div class="form__group--border pt-32 pb-16">
  <fieldset>
    <legend class="form__label pb-8">What types of housekeeping services do you provide?</legend>
    <ul ref="servicesCheckboxList">
      <li v-for="service in serviceTypes" :key="service.value">
        <PoppinsCheckbox
          v-model="services"
          :labelName="service.optionText"
          :aria-label="generateScreenReaderLabel(service.optionText)"
          :value="service.value"
          :required="true"
          :status="formStatuses.services"
          @blur="validate"
        />
      </li>
    </ul>
    <HelperText v-if="!formStatuses.services" class="!-mt-16 mb-16" :text="helperText" :status="helperStatus.Error" />
  </fieldset>
</div>
